export const ALL = 'ALL'
export const SELECTED = 'SELECTED'



// WEBPACK FOOTER //
// ./src/modules/Framework/ExportButton/Constants/actions.js